import { render, staticRenderFns } from "./ParentFoo.vue?vue&type=template&id=a748b27e&"
import script from "./ParentFoo.vue?vue&type=script&lang=js&"
export * from "./ParentFoo.vue?vue&type=script&lang=js&"
import style0 from "./ParentFoo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports